var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2 white--text",staticStyle:{"pointer-events":"none"},attrs:{"tile":"","color":_vm.btnColor,"outlined":"","small":""}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }